const { __ } = wp.i18n;

function EntidadesNotFound() {
  return (
    <div className="alert alert-warning" role="alert">
      { __('No se encontraron entidades', 'bizum-website') }
    </div>
  )
}

export default EntidadesNotFound